import React from 'react'
import Layout from '../../../../Layout/Layout'
import { useForm } from '@inertiajs/react'
import ParticipantUidHeading from '../../../../Components/ParticipantUidHeading'
import FormButton from '../../../../Components/FormButton'
import { parseJSON, parseISO, format, parse } from 'date-fns'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'

export default function Edit({ respite }) {
    const { data, setData, put, processing, errors } = useForm({
        manual_start_time: respite.manual_start_time || '',
        manual_end_time: respite.manual_end_time || '',
        notes: respite.notes || '',
    })

    function handleSubmit(e) {
        e.preventDefault()
        put(route('respite.update', respite.id), data)
    }

    return (
        <Layout title="Respite Services">
            <form onSubmit={handleSubmit}>
                <div className="flex flex-col flex-wrap w-full bg-white shadow-md p-8 md:p-16 md:mb-0 mt-2">
                    <div className="flex flex-row flex-wrap items-center mb-4">
                        <h5 className="text-2xl text-gray-700 mr-2">
                            Editing:{' '}
                        </h5>
                        <p className="text-2xl font-semibold">
                            {respite.participant.first_name +
                                ' ' +
                                respite.participant.last_name}
                        </p>
                        <ParticipantUidHeading
                            newUid={respite.participant.new_participant_uid}
                            oldUid={respite.participant.participant_uid}
                        />
                    </div>
                    <div className="flex flex-row flex-wrap items-center my-6">
                        <h5 className="text-2xl text-gray-700 mr-2 w-full">
                            Respite Services Start & End Time:
                        </h5>
                        {errors.manual_start_time ? (
                            <p className="italic text-red-500 text-sm w-full">
                                {errors.manual_start_time}
                            </p>
                        ) : null}
                        {errors.manual_end_time ? (
                            <p className="italic text-red-500 text-sm w-full">
                                {errors.manual_end_time}
                            </p>
                        ) : null}
                        <div className="flex flex-row flex-wrap gap-2 mt-8 items-center gap-4">
                            <div className="flex flex-col items-start gap-2">
                                <label
                                    className="block text-gray-700 text-sm mb-2 "
                                    htmlFor="manual_start_time"
                                >
                                    Start Time
                                </label>
                                <DatePicker
                                    showTimeInput
                                    dateFormat="h:mm aa"
                                    showTimeSelectOnly
                                    timeIntervals={15}
                                    timeCaption="Time"
                                    selected={
                                        data.manual_start_time
                                            ? new Date(
                                                  data.manual_start_time.endsWith(
                                                      'Z'
                                                  )
                                                      ? data.manual_start_time
                                                      : data.manual_start_time +
                                                            'Z'
                                              )
                                            : null
                                    }
                                    onChange={(date) =>
                                        setData(
                                            'manual_start_time',
                                            date ? date.toISOString() : null
                                        )
                                    }
                                    className="w-full h-10 pl-2 text-gray-700 border border-gray-400"
                                />
                                <button
                                    type="button"
                                    className="bg-gray-200 w-full rounded p-2 whitespace-nowrap hover:bg-gray-100"
                                    onClick={(e) => {
                                        e.preventDefault()
                                        setData(
                                            'manual_start_time',
                                            new Date().toISOString()
                                        )
                                    }}
                                >
                                    Now
                                </button>
                            </div>
                            <div className="flex flex-col items-start gap-2">
                                <label
                                    className="block text-gray-700 text-sm mb-2 ml-1"
                                    htmlFor="manual_end_time"
                                >
                                    End Time
                                </label>

                                <DatePicker
                                    showTimeInput
                                    dateFormat="h:mm aa"
                                    showTimeSelectOnly
                                    timeIntervals={15}
                                    timeCaption="Time"
                                    selected={
                                        data.manual_end_time
                                            ? new Date(
                                                  data.manual_end_time.endsWith(
                                                      'Z'
                                                  )
                                                      ? data.manual_end_time
                                                      : data.manual_end_time +
                                                            'Z'
                                              )
                                            : null
                                    }
                                    onChange={(date) =>
                                        setData(
                                            'manual_end_time',
                                            date ? date.toISOString() : null
                                        )
                                    }
                                    className="w-full h-10 pl-2 text-gray-700 border border-gray-400"
                                />
                                <button
                                    type="button"
                                    className="bg-gray-200 w-full rounded p-2 whitespace-nowrap hover:bg-gray-100"
                                    onClick={(e) => {
                                        e.preventDefault()
                                        setData(
                                            'manual_end_time',
                                            new Date().toISOString()
                                        )
                                    }}
                                >
                                    Now
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="flex flex-col items-start gap-2 w-full p-4 shadow-sm mt-4">
                        <label
                            htmlFor="notes"
                            className="block text-gray-700 font-medium mb-2"
                        >
                            Notes
                        </label>
                        <textarea
                            className="w-full text-gray-700 border border-gray-200 min-h-24 p-2"
                            id="notes"
                            placeholder="Notes"
                            value={data.notes}
                            onChange={(e) => setData('notes', e.target.value)}
                        />
                    </div>
                </div>
                <div className="w-full flex flex-row flex-wrap bg-customBlue md:space-x-4 space-y-4 md:space-y-0 items-center py-7 px-8 md:px-16 mb-8">
                    <button
                        type="submit"
                        className="bg-white text-customBlue h-12 py-2 px-8 w-full justify-center md:w-auto font-bold flex flex-row items-center"
                        disabled={processing}
                    >
                        {processing && (
                            <div>
                                <svg
                                    className="animate-spin mr-2"
                                    width="18px"
                                    height="18px"
                                    viewBox="0 0 120 120"
                                >
                                    <g
                                        id="Artboard"
                                        stroke="none"
                                        strokeWidth="1"
                                        fill="none"
                                        fill-rule="evenodd"
                                    >
                                        <g
                                            id="Group"
                                            transform="translate(9.000000, 9.000000)"
                                            stroke="#314EB9"
                                            strokeWidth="9"
                                        >
                                            <path
                                                d="M102,51 C102,22.8334778 79.1665222,0 51,0 C22.8334778,0 0,22.8334778 0,51 C0,79.1665222 22.8334778,102 51,102"
                                                id="Path"
                                            ></path>
                                        </g>
                                    </g>
                                </svg>
                            </div>
                        )}
                        Done
                    </button>
                    <div className="flex-col md:flex-row items-center w-auto md:w-auto bg-white rounded-full py-2">
                        <div className="flex flex-row items-center px-4">
                            <small className="pr-2">Step 1 of 1</small>
                            <div className="h-4 w-4 rounded-full bg-customBlue"></div>
                        </div>
                    </div>
                </div>
            </form>
        </Layout>
    )
}
